import React, { useState } from "react";
import moment from "moment";
import QuestionShort from "../../../profile/components/QuestionShort";
import QuestionMultiple from "../../../profile/components/QuestionMultiple";
import QuestionScale from "../../../profile/components/QuestionScale";
import BodyWeightStats from "../../../calendar/body-composition/components/BodyWeightStats";
import { ProgressPictureAnswer } from "../../../profile/components/QuestionProgressPictures";
import NutritionHistoryTable from "../../../nutrition/components/NutritionHistoryTable";
import { getSingleAverageStat } from "../../../../../utils/nutrition-helpers";
import SummaryPersonalStats from "./SummaryPersonalStats";
import SummaryVideoList from "./SummaryVideoList";
import { frequencyLimit } from "../../../../../utils/questionnaire";
import VideoRecordComponent from "../../../../../parts/VideoRecordComponent";
import {
  DATE_FORMATS,
  defaultFirebaseProjectId,
} from "../../../../../constants";
import Avatar from "../../../../../parts/avatar";
import SvgIcon from "../../../../../parts/SvgIcon";
import submit from "submit-form";
const { DATE_DAY_FORMAT, UTC } = DATE_FORMATS;
import SummaryDailyStats from "./SummaryDailyStats";
import BodyMeasureStats from "../../../calendar/body-composition/components/BodyMeasureStats";

const DisplaySummaryQuestions = ({
  answerStats,
  dailyStats,
  threeMonthData,
  athlete,
  date,
  units,
  nutritionPlans,
  dayPersonalRecords,
  locals,
  query,
  activeExercises,
}) => {
  const organizationCoach = query.organizationCoach || undefined;
  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  const { questionnaire, utcDate } = answerStats;
  const { questionnaireFrequency } = questionnaire;
  // This is done because the answers are stored in the order they are answered in
  // It is also necessary to include the slice() as reverse() mutates the original array
  const reversedAnswers = questionnaire.questionnaireAnswers.slice().reverse();
  const timePeriod = frequencyLimit[questionnaireFrequency];

  const end = moment(utcDate, "YYYYMMDD").format("YYYY-MM-DD");
  const start = moment(utcDate, "YYYYMMDD")
    .subtract(timePeriod - 1, "days")
    .format("YYYY-MM-DD");

  // Stats in the date range of the check in period
  const filteredStats = dailyStats
    .filter(
      (stat) =>
        stat.utcDate >= Number(moment(start).format("YYYYMMDD")) &&
        stat.utcDate <= Number(moment(end).format("YYYYMMDD"))
    )
    .slice()
    .sort((a, b) => b.utcDate - a.utcDate);

  // So we can implement the rest day on the check in nutrition table
  const statsWithoutWeekAverage = filteredStats.map((stat) => {
    const exercise = activeExercises.find((ex) => ex.utcDate === stat.utcDate);
    stat.hasWorkout = !!exercise;
    return stat;
  });

  // Average stats for the nutrition table, it's a single average that includes all the values from that period of time
  const averageStats = getSingleAverageStat(start, end, dailyStats);
  // Combines both arrays of data for the nutrition table, the average will always be displayed first
  const nutritionHistory = statsWithoutWeekAverage
    .concat(averageStats)
    .sort((a, b) => b.utcDate - a.utcDate);

  return (
    <div className="Check-in-Questionnaire">
      {reversedAnswers.map((answer) => (
        <DisplaySingleQuestion
          singleAnswer={answer}
          key={answer._id}
          dailyStats={filteredStats}
          athlete={athlete}
          date={date}
          threeMonthData={threeMonthData}
          start={start}
          end={end}
          units={units}
          timePeriod={timePeriod}
          nutritionPlans={nutritionPlans}
          nutritionHistory={nutritionHistory}
          organizationCoachParam={organizationCoachParam}
          activeExercises={activeExercises}
        />
      ))}

      {/* Records, Workload and Video List */}
      <SummaryPersonalStats
        start={start}
        end={end}
        units={units}
        dayPersonalRecords={dayPersonalRecords}
      />

      <SummaryDailyStats
        dailyStats={filteredStats}
        date={date}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />

      <SummaryVideoList
        start={start}
        end={end}
        date={date}
        locals={locals}
        query={query}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />

      <footer key={`${date}-${athlete._id}-check-in-video-loom`}>
        <h4>Coach Review</h4>

        <div>
          <VideoRecordComponent
            date={moment().format(DATE_DAY_FORMAT)}
            unformattedDate={moment(date, UTC)}
            videoRecordEmbed={
              locals.videoRecord ? locals.videoRecord.embedUrl : null
            }
            locals={locals}
            type={"check-in"}
            reportDate={moment(date, UTC).format(DATE_DAY_FORMAT)}
          />
          <CheckInNotes locals={locals} checkInDate={date} />
        </div>
      </footer>
    </div>
  );
};

const CheckInNotes = ({ locals, checkInDate }) => {
  const {
    workoutCoachNote,
    workoutNote,
    activeUserToRequest,
    athlete,
    coachOrganizationInformation,
    query,
    activeUser,
  } = locals;

  const [openQuickEditCoachNotes, setOpenQuickEditCoachNotes] = useState(false);
  const [coachNote, setCoachNote] = useState(
    workoutCoachNote?.note?.note || ""
  );
  const athleteNote = workoutNote?.note?.note || "";

  const handleCoachNoteChange = (value) => {
    setCoachNote(value);
  };

  const saveQuickEditCoachNotes = () => {
    submit("/actions/exercise/quick-edit-coach-note", {
      method: "POST",
      body: {
        note: coachNote,
        date: moment(checkInDate, UTC).format(DATE_DAY_FORMAT),
        user: athlete._id,
        coach: query.organizationCoach || activeUser._id,
        avatar:
          !!activeUser.avatar && !!activeUser.avatar.file
            ? activeUser.avatar.file
            : null,
        firebaseProjectId: !!activeUserToRequest.firebaseProjectId
          ? activeUserToRequest.firebaseProjectId
          : defaultFirebaseProjectId,
        type: "check-in",
      },
    });

    // Idk lol
    if (
      locals.workoutCoachNote &&
      locals.workoutCoachNote.note &&
      locals.workoutCoachNote.note.note
    ) {
      locals.workoutCoachNote.note.note = coachNote;
    } else {
      locals.workoutCoachNote = {
        note: { note: coachNote },
      };
    }

    setOpenQuickEditCoachNotes(false);
  };

  const closeQuickEditCoachNotes = () => {
    // So it goes back to it's previous state
    setCoachNote(workoutCoachNote?.note?.note || "");
    setOpenQuickEditCoachNotes(false);
  };

  return (
    <div className="notes-container">
      <div className="coach-notesx">
        <label>Notes</label>
        <>
          {!openQuickEditCoachNotes ? (
            <div
              className="edit-mode"
              onClick={() => {
                setOpenQuickEditCoachNotes(true);
              }}
            >
              <div className="only-show-mobile">
                {coachNote.trim().length ? (
                  <Avatar
                    size={32}
                    className={`note-avatar only-show-mobile`}
                    user={coachOrganizationInformation}
                  />
                ) : null}
                <div>
                  {coachNote.trim().length ? (
                    <span className={`coach-name`}>
                      {athlete && athlete.coach && athlete.coach.name}
                    </span>
                  ) : null}
                  <span className="click-add">
                    {coachNote.trim().length ? coachNote : "Tap to add note"}
                  </span>
                </div>
              </div>
              <span className="mobile-hidden">
                {coachNote.trim().length
                  ? coachNote
                  : "Click to add/edit notes"}
              </span>
            </div>
          ) : (
            <div className="edit-mode editing">
              <textarea
                value={coachNote || ""}
                onChange={({ target: { value } }) =>
                  handleCoachNoteChange(value)
                }
                id="coach-notes-textarea"
                autoFocus={true}
              />
              <div className="button-container">
                <button
                  data-button-type="primary"
                  onClick={() => saveQuickEditCoachNotes()}
                >
                  Save
                </button>
                <button
                  data-button-type="secondary"
                  onClick={() => closeQuickEditCoachNotes()}
                >
                  <SvgIcon
                    src="/img/new-icons/red-cross.svg"
                    noFilterOnLight={true}
                  />
                </button>
              </div>
            </div>
          )}
        </>
      </div>
      {athleteNote && athleteNote.trim().length ? (
        <div className="athlete-notes">
          <label>
            {activeUser.referAsClients ? "Client Notes" : "Athlete Notes"}
          </label>
          <div className="edit-mode !cursor-default">
            <span className={`athlete-name only-show-mobile`}>
              {athlete && athlete.name}
            </span>
            <span>{athleteNote}</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const DisplaySingleQuestion = ({
  singleAnswer,
  dailyStats,
  threeMonthData,
  athlete,
  date,
  start,
  end,
  units,
  timePeriod,
  nutritionPlans,
  nutritionHistory,
  organizationCoachParam,
  activeExercises,
}) => {
  const { type, answer, questionBody, questionTitle } = singleAnswer;

  // Cuz we are already showing these without the need for a question
  if (type === "sleep" || type === "steps" || type === "hrv") return null;

  const questionDisplayTitle = getQuestionTitle(type, questionTitle);

  const questionDisplayBody = getQuestionBody(
    type,
    questionBody,
    answer,
    {
      dailyStats,
      threeMonthData,
      athlete,
      date,
      start,
      end,
      units,
      timePeriod,
      nutritionPlans,
      nutritionHistory,
      activeExercises,
    },
    organizationCoachParam
  );

  return (
    <div className={"questionnaire-question"}>
      <div className="question-header">
        <h4>{questionDisplayTitle}</h4>
      </div>
      <div className="question-body">{questionDisplayBody}</div>
    </div>
  );
};

const getQuestionTitle = (type, questionTile) => {
  switch (type) {
    case "short":
    case "multiple":
    case "checkbox":
    case "scale":
    case "measurement":
      return questionTile;
    case "bodyweight":
      return "";
    case "nutrition":
      return "Nutrition Summary";
    case "progress":
      return "Progress Photos";
  }
};

const getQuestionBody = (type, body, answer, data, organizationCoachParam) => {
  const {
    dailyStats,
    threeMonthData,
    athlete,
    date,
    start,
    end,
    units,
    timePeriod,
    nutritionPlans,
    nutritionHistory,
    activeExercises,
  } = data;

  if (!answer && type !== "progress") {
    return <div>Error displaying the question</div>;
  }

  // Could be converted to a dictionary, but there are too many different attributes in the components so I leave it like this for now
  switch (type) {
    case "short":
      return <QuestionShort description={answer.value} />;
    case "multiple":
    case "checkbox":
      return (
        <QuestionMultiple
          type={body.type}
          options={body.options}
          answers={answer.value}
        />
      );
    case "scale":
      return (
        <QuestionScale
          labelLeft={body.labelLeft}
          labelRight={body.labelRight}
          answer={answer.value}
        />
      );
    case "bodyweight":
      return (
        <BodyWeightStats
          dailyStats={dailyStats}
          athlete={athlete._id}
          date={date}
          threeMonthData={threeMonthData}
          start={start}
          end={end}
          units={units}
          timePeriod={timePeriod}
          organizationCoachParam={organizationCoachParam}
          fromCheckIn={true}
        />
      );
    case "progress":
      return <ProgressPictureAnswer answer={answer} dailyStats={dailyStats} />;
    case "nutrition":
      return (
        <NutritionHistoryTable
          units={units}
          nutritionHistory={nutritionHistory}
          nutritionPlans={nutritionPlans}
          isCheckIn={true}
          activeExercises={activeExercises}
        />
      );
    case "measurement":
      return (
        <BodyMeasureStats
          data={threeMonthData}
          athlete={athlete._id}
          date={date}
          units={units}
          organizationCoachParam={organizationCoachParam}
        />
      );
    default:
      return <div>Error displaying the question</div>;
  }
};

export default DisplaySummaryQuestions;
